import { ImageWithFallback } from './ImageWithFallback';
import { Card } from '../ui/card';
import { Badge } from '../ui/badge';
import { Calendar, MapPin, Clock } from 'lucide-react';
import { Button } from '../ui/button';
import {
    Carousel,
    CarouselContent,
    CarouselItem,
    CarouselNext,
    CarouselPrevious,
} from "../ui/carousel";
import event11 from "../../assets/img/HomePage/events/event-1/image1.jpeg";
import event12 from "../../assets/img/HomePage/events/event-1/image2.jpeg";
import event13 from "../../assets/img/HomePage/events/event-1/image3.jpeg";
import event14 from "../../assets/img/HomePage/events/event-1/image4.jpeg";

import event21 from "../../assets/img/HomePage/events/event-2/image1.jpeg";
import event22 from "../../assets/img/HomePage/events/event-2/image2.jpeg";
import event23 from "../../assets/img/HomePage/events/event-2/image3.jpeg";
import event24 from "../../assets/img/HomePage/events/event-2/image4.jpeg";

import event31 from "../../assets/img/HomePage/events/event-3/image1.jpeg";
import event32 from "../../assets/img/HomePage/events/event-3/image2.jpeg";
import event33 from "../../assets/img/HomePage/events/event-3/image3.jpeg";
import event34 from "../../assets/img/HomePage/events/event-3/image4.jpeg";
import { useEffect } from 'react';

const loadImages = (folderPath: string) => {
    try {
        const context = (require as any).context(
            folderPath,
            true,                          // search subfolders
            /\.(png|jpg|jpeg|webp)$/       // match image extensions
        );
        return context.keys().map(context);
    } catch (error) {
        console.error("Image folder not found:", folderPath);
        return [];
    }
};

const importAll = (r: any) => r.keys().map(r);


const UpcomingEventsComponent = () => {

    // const images = importAll(
    //     (require as any).context('../../assets/img/HomePage/events/event-1', false, /\.(png|jpe?g|svg)$/)
    // );

    // console.log(images);

    // useEffect(() => {
    //     console.log("Testing path:");
    //     console.log(loadImages("../../assets/img/HomePage/events/event-1"));
    // }, []);
    //const event1Images = loadImages("../../assets/img/Events/HomePage/events/event-1");
    const event1Images = [event11, event12, event13, event14];
    const event2Images = [event21, event22, event23, event24];
    const event3Images = [event31, event32, event33, event34];
    // console.log("Event 1 Images:", event1Images);
    const upcomingEvents = [
        {
            title: 'ಅರುಣ ಹೋಮ',
            date: 'ಜುಲೈ 06 ಮತ್ತು 07 2024',
            time: '10:00 AM - 4:00 PM',
            location: 'ಚಿಂತಾಮಣಿ',
            category: 'ಕಾರ್ಯಕ್ರಮ',
            images: event1Images,
            description: 'ಚಿಂತಾಮಣಿ ತಾಲ್ಲೂಕು ಬ್ರಾಹ್ಮಣ ಮಹಾಸಭಾ ವತಿಯಿಂದ ಜುಲೈ 6 ಶನಿವಾರ ಮತ್ತು ಜುಲೈ 7 ಭಾನುವಾರದಂದು ಶ್ರೀ ರಾಘವೇಂದ್ರ ಸ್ವಾಮಿ ಮಠದ ಆವರಣದಲ್ಲಿ ಭಗವಂತನ  ಪ್ರೇರಣೆಯಿಂದ ಅರುಣಹೋಮವನ್ನು ನೆರೆವೇರಿಸಲಾಯಿತು. ಹೋಮದ ಅಂಗವಾಗಿ 07/07/2024 ಭಾನುವಾರ ಋತ್ವೀಕರಿಂದ ಅರುಣಹೋಮ ಮತ್ತು ಪೂರ್ಣಾಹುತಿ ಶ್ರೀ ಲಕ್ಷ್ಮಣ ಶರ್ಮಾ ಘನಪಾಟಿಗಳ ಉಪಸ್ಥಿತಿಯಲ್ಲಿ ಮಾಡಲಾಯಿತು.',
        },
        {
            title: '2024 ಕನ್ನಡ ರಾಜ್ಯೋತ್ಸವ ಮತ್ತು ಕ್ಯಾಲೆಂಡರ್ ಬಿಡುಗಡೆ',
            date: '30-11-2024',
            time: '10:00 AM - 4:00 PM',
            location: 'ಚಿಂತಾಮಣಿ',
            category: 'ಕಾರ್ಯಕ್ರಮ',
            images: event2Images,
            description: '2025 ನೇ ವರ್ಷದ ಕ್ಯಾಲೆಂಡರ್ ಬಿಡುಗಡೆ ಮತ್ತು ಕನ್ನಡ ರಾಜ್ಯೋತ್ಸವ ಕಾರ್ಯಕ್ರಮವನ್ನು  ಚಿಂತಾಮಣಿ ನಗರದ ಬ್ರಾಹ್ಮಣರ ಬೀದಿಯಲ್ಲಿರುವ ಶ್ರೀ ಶಾರದಾ ಶಂಕರ ಪ್ರಾರ್ಥನಾ ಮಂದಿರದಲ್ಲಿ ಹಮ್ಮಿಕೊಳ್ಳಲಾಯಿತು.',
        },
        {
            title: 'ವಾರ್ಷಿಕ ಮಹಾಸಭೆ ಮತ್ತು ಪ್ರತಿಭಾ ಪುರಸ್ಕಾರ 2025',
            date: '24/08/2025',
            time: '10:00 AM - 7:00 PM',
            location: 'ಶ್ರೀ ರಾಘವೇಂದ್ರ ಸ್ವಾಮಿ ಮಠದ ಆವರಣ, ಚಿಂತಾಮಣಿ',
            category: 'ಕಾರ್ಯಕ್ರಮ',
            images: event3Images,
            description: '2025 ಸಾಲಿನ ವಾರ್ಷಿಕ ಮಹಾಸಭೆ ಮತ್ತು ಪ್ರತಿಭಾ ಪುರಸ್ಕಾರ ಕಾರ್ಯಕ್ರಮದ ಅಧ್ಯಕ್ಷತೆಯನ್ನು ಶ್ರೀ ಎನ್. ಕೃಷ್ಣ ರವರು ವಹಿಸಿದ್ದರು. ಮುಖ್ಯ ಅತಿಥಿಗಳಾಗಿ  ಪಿ.ಆರ್. ಜನಾರ್ಧನ್ ರವರು ಆರಕ್ಷಕ ವೃತ್ತ ನಿರೀಕ್ಷಕರು ಚೇಳೂರು ಪೊಲೀಸ್ ಠಾಣೆ. ಮತ್ತು ಬಿ ಆರ್. ಶ್ರೀನಾಥ್ ರವರು ಹಿರಿಯ ವಕೀಲರು ಮತ್ತು ಸಂಘದ ಮಾರ್ಗದರ್ಶಿಗಳು ಇವರು ಆಗಮಿಸಿದ್ದರು.',
        },
    ];

    return (
        <section id="events" className="py-20 bg-white">
            <div className="container mx-auto px-4">
                {/* Section Header */}
                <div className="text-center mb-16">
                    <h2 className="text-4xl md:text-5xl text-[#4A0404] mb-4">
                        ಕಾರ್ಯಕ್ರಮಗಳು
                    </h2>
                    <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                        ನಮ್ಮ ಮುಂದಿನ ಮತ್ತು ಹಳೆಯ ಕಾರ್ಯಕ್ರಮಗಳು ಹಾಗೂ ಘಟನೆಗಳ ಪಟ್ಟಿ
                    </p>
                </div>

                {/* Upcoming Events Grid */}
                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {upcomingEvents.map((event, index) => (
                        <Card key={index} className="p-6 hover:shadow-lg transition-shadow group">
                            <div className="relative h-48 overflow-hidden">
                                <Carousel className="w-full h-full">
                                    <CarouselContent>
                                        {event.images.map((image: any, imgIndex: any) => (
                                            <CarouselItem key={imgIndex}>
                                                <ImageWithFallback
                                                    src={image}
                                                    alt={`${event.title} - Image ${imgIndex + 1}`}
                                                    className="w-full h-48 object-fill rounded-md"
                                                    style={{ objectFit: "contain" }}
                                                />
                                            </CarouselItem>
                                        ))}
                                    </CarouselContent>
                                    {event.images.length > 1 && (
                                        <>
                                            <CarouselPrevious className="absolute left-2 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white text-[#4A0404] border-none h-8 w-8" />
                                            <CarouselNext className="absolute right-2 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white text-[#4A0404] border-none h-8 w-8" />
                                        </>
                                    )}
                                </Carousel>
                                <Badge className="absolute top-4 right-4 bg-[#800000] hover:bg-[#800000] z-10 pointer-events-none">
                                    {event.category}
                                </Badge>
                            </div>
                            <div className="p-6">
                                <h3 className="text-2xl text-[#4A0404] mb-3">{event.title}</h3>
                                <p className="text-gray-600 mb-4">{event.description}</p>
                                <div className="space-y-2 mb-4">
                                    <div className="flex items-center text-gray-700">
                                        <Calendar className="h-4 w-4 mr-2 text-[#F59E0B]" />
                                        <span>{event.date}</span>
                                    </div>
                                    <div className="flex items-center text-gray-700">
                                        <Clock className="h-4 w-4 mr-2 text-[#F59E0B]" />
                                        <span>{event.time}</span>
                                    </div>
                                    <div className="flex items-center text-gray-700">
                                        <MapPin className="h-4 w-4 mr-2 text-[#F59E0B]" />
                                        <span>{event.location}</span>
                                    </div>
                                </div>
                                <Button className="w-full bg-[#4A0404] hover:bg-[#4A0404]/90">
                                    View Details
                                </Button>
                            </div>
                        </Card>
                    ))}
                </div>
            </div>
        </section>
    );
};
export default UpcomingEventsComponent; 